import React, { createContext, useContext, useState } from "react";

// Create the context
const ToolbarStateContext = createContext<{
  selectedMode: "arrow" | "hazard" | "surface" | "text" | null;
  setSelectedMode: (
    mode: "arrow" | "hazard" | "surface" | "text" | null,
  ) => void;
} | null>(null);

// Custom hook to use the context
export const useToolbarState = () => {
  const context = useContext(ToolbarStateContext);
  if (!context) {
    throw new Error(
      "useToolbarState must be used within a ToolbarStateProvider",
    );
  }
  return context;
};

// Provider component
export const ToolbarStateProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [selectedMode, setSelectedMode] = useState<
    "arrow" | "hazard" | "surface" | "text" | null
  >(null);

  const value = {
    selectedMode,
    setSelectedMode,
  };

  return (
    <ToolbarStateContext.Provider value={value}>
      {children}
    </ToolbarStateContext.Provider>
  );
};

export default ToolbarStateProvider;
